import { ParsedUrlQuery } from 'querystring';
import { env } from '../util/env';
import { useServices } from './Services';
import { SsrData } from './SsrData';

export const makeFlags = (ssrData: SsrData, query?: ParsedUrlQuery): Flags => {
  const slot = ssrData.slot('FLAGS', (): Flags => ({}));

  const envFlags = env.FLAGS;

  if (envFlags !== '') {
    envFlags.split(',').forEach(key => {
      slot[key] = true;
    });
  }

  if (query) {
    Object.keys(query).forEach(key => {
      if (key.startsWith('flag-')) {
        const falsy = query[key] === '0' || query[key] === 'false';
        slot[key.substr(5)] = !falsy;
      }
    });
  }

  return slot;
};

export type Flags = Record<string, boolean>;

export const useFlags = () => useServices().flags;
